/**
 * Base Service each new Service extends from.
 */
export class BaseService {
  public apiURL = process.env.REACT_APP_ENVELO_API_ENDPOINT;
  get authToken(): string {
    return sessionStorage.getItem('authToken') as string;
  }
}
